// extracted by mini-css-extract-plugin
export default {"scoreContainer":"ScoreBox_scoreContainer__65hhq","score":"ScoreBox_score__Pa1DP"};